/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useRef } from 'react'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import thLocale from 'date-fns/locale/th'
import OverwriteFnsBE from './OverwriteFnsBE'
import OverwriteFnsAD from './OverwriteFnsAD'

import Box from '@mui/material/Box'
import InputMask from 'react-input-mask'

import classNames from 'classnames/bind'
import './datepicker-custom-styles.css'

import { startOfWeek, endOfWeek } from 'date-fns'
import dayjs from 'dayjs'
import moment from 'moment'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { pickerTheme } from 'designer/component/system/themes/elementTheme'
import { ThemeProvider } from '@mui/material/styles'
dayjs.extend(customParseFormat)

const DatePickerCustom = ({
  dateAdapter,
  locale,
  value,
  onChange,
  onViewChange,
  placeholder,
  formatDisplay,
  maskSign,
  isClearable,
  isError,
  field,
  inputId,
  inputAriaLabel,
  useBE = true,
  inputUseBE = true,
  ...props
}) => {
  const retryRef = useRef(0)
  let formatDsp = formatDisplay ?? 'DD/MM/YYYY'
  let maskInput =
    formatDisplay && maskSign
      ? formatDsp.split('').reduce((items, item) => {
          if (item === maskSign) {
            items += maskSign
          } else {
            items += 9
          }
          return items
        }, '')
      : '99/99/9999'

  const startWeek = startOfWeek(new Date())
  const endWeek = endOfWeek(new Date())

  const parseStringDate = (dateString) => {
    return dayjs(dateString).toDate()
  }

  const convertDate = (data) => {
    if (data) {
      const date = dayjs(data, formatDsp)
      if (date.isValid()) {
        if (inputUseBE) {
          const ceYear = date.year() - 543
          const ceDate = `${ceYear}${date.format('-MM-DD')}`
          return parseStringDate(ceDate)
        }

        return date.toDate()
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  const [dateValue, setDateValue] = useState()
  const [dateText, setDateText] = useState()

  useMemo(() => {
    if (value) {
      if (value === '') {
        setDateValue('')
        setDateText('')
      } else {
        setDateValue(value)
        let newDate = dayjs(value).add(543, 'year').format(formatDsp)
        // setDateText(newDate)
        setDateText(
          useBE
            ? dayjs(value).add(543, 'year').format(formatDsp)
            : dayjs(value).format(formatDsp),
        )
      }
    } else {
      setDateValue('')
      setDateText('')
    }
  }, [value])

  const handleChangeDateText = (value) => {
    // let { value } = e.target

    if (field) {
      if (value) {
        setDateText(value)
      } else {
        let dateNow = dayjs().format('YYYY-MM-DD')
        let newDate = dayjs(dateNow).add(543, 'year').format(formatDsp)
        if (field === 'startOfWeek') {
          newDate = useBE
            ? moment(startWeek).add(543, 'y').format('DD/MM/YYYY')
            : moment(startWeek).format('DD/MM/YYYY')
        } else if (field === 'endOfWeek') {
          newDate = useBE
            ? moment(endWeek).add(543, 'y').format('DD/MM/YYYY')
            : moment(endWeek).format('DD/MM/YYYY')
        } else {
          newDate = useBE
            ? moment(dateNow).add(543, 'y').format('DD/MM/YYYY')
            : moment(dateNow).format('DD/MM/YYYY')
        }
        setDateText(newDate)
      }
    } else {
      setDateText(value)
    }

    let newDate = convertDate(value)
    if (newDate) {
      let dateFormat = inputUseBE
        ? dayjs(newDate).add(543, 'year').format('YYYY-MM-DD')
        : dayjs(newDate).format('YYYY-MM-DD')
      setDateValue(newDate)

      if (onChange) {
        onChange({ value: newDate, format: dateFormat })
      }
    }
  }

  const handleChangeDate = (date) => {
    setDateValue(date)

    let dateFormat = useBE
      ? dayjs(date).add(543, 'year').format('YYYY-MM-DD')
      : dayjs(date).format('YYYY-MM-DD')

    let dateDisplay = useBE
      ? dayjs(date).add(543, 'year').format(formatDsp)
      : dayjs(date).format(formatDsp)

    setDateText(dateDisplay)

    if (onChange) {
      onChange({ value: date, format: dateFormat })
    }
  }

  const clearDate = () => {
    setDateValue('')
    setDateText('')

    if (onChange) {
      onChange({})
    }
  }

  //// scroll to current year /////

  const scrollToCurrentYear = () => {
    retryRef.current = 0

    const tryScroll = () => {
      const selectors = [
        '.MuiYearCalendar-root button',
        '.MuiPickersYear-root button',
        '[role="gridcell"] button',
        '.MuiCalendarPicker-root button',
        'button',
      ]
      const possibleButtons = Array.from(
        document.querySelectorAll(selectors.join(',')),
      )

      if (!possibleButtons.length) {
        retry()
        return
      }

      const numericButtons = possibleButtons.filter((btn) => {
        const t = btn.textContent?.trim()
        return !!t && /^\d{3,4}$/.test(t)
      })

      if (!numericButtons.length) {
        retry()
        return
      }

      const ceYear = new Date().getFullYear()
      const beYear = ceYear + 543

      const showsBE = numericButtons.some(
        (b) => b.textContent.trim() === String(beYear),
      )
      const targetText = showsBE ? String(beYear) : String(ceYear)

      const targetBtn = numericButtons.find(
        (b) => b.textContent.trim() === targetText,
      )

      if (!targetBtn) {
        const fuzzy = numericButtons.find(
          (b) => Math.abs(Number(b.textContent.trim()) - ceYear) <= 543,
        )
        if (fuzzy) {
          scrollIntoContainer(fuzzy)
          return
        }
        retry()
        return
      }

      scrollIntoContainer(targetBtn)
    }

    const retry = () => {
      retryRef.current += 1
      if (retryRef.current > 6) return

      setTimeout(() => requestAnimationFrame(tryScroll), 80)
    }

    const scrollIntoContainer = (targetBtn) => {
      let container = targetBtn.parentElement
      while (container && container !== document.body) {
        const style = window.getComputedStyle(container)
        if (/(auto|scroll)/.test(style.overflowY)) break
        container = container.parentElement
      }

      if (container && container !== document.body) {
        const offset =
          targetBtn.offsetTop -
          container.offsetTop -
          container.clientHeight / 2 +
          targetBtn.clientHeight / 2
        container.scrollTo({ top: offset, behavior: 'smooth' })
      } else {
        targetBtn.scrollIntoView({ block: 'center', behavior: 'smooth' })
      }

      try {
        targetBtn.focus()
      } catch (e) {}
    }

    requestAnimationFrame(tryScroll)
  }

  const handleViewChange = (view) => {
    if (view === 'year') {
      scrollToCurrentYear()
    }
    onViewChange?.(view)
  }

  ///

  return (
    <LocalizationProvider
      dateAdapter={useBE ? OverwriteFnsBE : OverwriteFnsAD}
      locale={locale ?? thLocale}
    >
      <ThemeProvider theme={pickerTheme}>
        <DatePicker
          views={['year', 'month', 'day']}
          value={dateValue}
          onViewChange={handleViewChange}
          onChange={(newValue) => {
            handleChangeDate(newValue)
          }}
          renderInput={({ inputRef, inputProps, InputProps }) => {
            return (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <div className="position-relative">
                  <InputMask
                    {...inputProps}
                    value={dateText}
                    onChange={(e) => {
                      let newValue = e.target?.value
                      if (field) {
                        if (newValue) {
                          if (newValue === '') {
                            if (field === 'startOfWeek') {
                              newValue = useBE
                                ? moment(startWeek)
                                    .add(543, 'y')
                                    .format('DD/MM/YYYY')
                                : moment(startWeek).format('DD/MM/YYYY')
                            } else if (field === 'endOfWeek') {
                              newValue = useBE
                                ? moment(endWeek)
                                    .add(543, 'y')
                                    .format('DD/MM/YYYY')
                                : moment(endWeek).format('DD/MM/YYYY')
                            } else {
                              newValue = useBE
                                ? moment().add(543, 'y').format('DD/MM/YYYY')
                                : moment().format('DD/MM/YYYY')
                            }
                          }
                        } else {
                          if (field === 'startOfWeek') {
                            newValue = useBE
                              ? moment(startWeek)
                                  .add(543, 'y')
                                  .format('DD/MM/YYYY')
                              : moment(startWeek).format('DD/MM/YYYY')
                          } else if (field === 'endOfWeek') {
                            newValue = useBE
                              ? moment(endWeek)
                                  .add(543, 'y')
                                  .format('DD/MM/YYYY')
                              : moment(endWeek).format('DD/MM/YYYY')
                          } else {
                            newValue = useBE
                              ? moment().add(543, 'y').format('DD/MM/YYYY')
                              : moment().format('DD/MM/YYYY')
                          }
                        }
                      }
                      handleChangeDateText(newValue)
                    }}
                    placeholder={placeholder ?? formatDsp}
                    mask={maskInput}
                    maskChar={null}
                  >
                    {(inputMaskProps) => {
                      return (
                        <input
                          id={inputId}
                          aria-label={inputAriaLabel}
                          className={classNames('form-control', {
                            'is-readonly': props.readOnly,
                            'input-date pr': isClearable,
                            'is-invalid': isError,
                          })}
                          ref={inputRef}
                          {...inputMaskProps}
                        />
                      )
                    }}
                  </InputMask>

                  {isClearable && dateText && (
                    <button
                      aria-label="ล้างวันที่"
                      className="clear-btn"
                      onClick={() => clearDate()}
                      title="ล้างวันที่"
                      type="button"
                    >
                      <i
                        className={classNames('fas fa-times clearable-btn', {
                          error: isError,
                        })}
                      />
                    </button>
                  )}
                </div>

                {InputProps?.endAdornment}
              </Box>
            )
          }}
          {...props}
        />
      </ThemeProvider>
    </LocalizationProvider>
  )
}

export default DatePickerCustom
